import { render, staticRenderFns } from "./CommonLeadDetails.vue?vue&type=template&id=0c8cc5bc&scoped=true&"
import script from "./CommonLeadDetails.vue?vue&type=script&lang=js&"
export * from "./CommonLeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommonLeadDetails.vue?vue&type=style&index=0&id=0c8cc5bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8cc5bc",
  null
  
)

export default component.exports